/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const skogsrejv: CommunityData = {
  code: "SKOGSREJV",
  name: "SKOGSREJV",
  thumbnail: "/assets/customizations/skogsrejv/skogsrejv-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sko-210`,
  socials: {
    instagramLink: "https://www.instagram.com/skogsrejv/",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#000000",
      alternativeLogo: {
        src: "/assets/customizations/skogsrejv/logo-white.svg",
        styles: "w-[85px]",
      },
      logo: {
        src: "/assets/customizations/skogsrejv/logo.svg",
        styles: "w-[110px] h-[125px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideStyles: "",
      asideBg: "#161C24",
      contentBg: "#ffffff",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/skogsrejv/skogsrejv-bg.png",
      bgMobile: "/assets/customizations/skogsrejv/skogsrejv-bg.png",
      nonMemberBg: "/assets/customizations/skogsrejv/skogsrejv-auth-bg.png",
      mainFont: "font-['SometypeMono']",
      primaryButton:
        "w-full sm:w-fit !h-[52px] bg-white border-[1px] border-[#161C24] !px-6 !text-[20px] !leading-[1] font-['Silkscreen'] tracking-[-0.16em] !text-black shadow-[2px_2px_0px_#2AD1FD] whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-[#2AD1FD] border-t",
      item: "font-['Silkscreen'] tracking-[-0.16em] drop-shadow-[1px_1px_0px_#2AD1FD] text-[18px] leading-[18px] h-[40px] flex sm:justify-start justify-center items-center uppercase text-[#FFFFFF] !pt-1",
      itemSelected: "bg-[#303843]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles:
        "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[32px] leading-8 pb-2",
      announcements: {
        customBg: "bg-[#FFFFFF]",
        lg: {
          title: "text-base sm:text-[22px] leading-[30px] font-['Silkscreen'] tracking-[-0.16em]",
          subtitle:
            "text-[11px] leading-[1] !text-black font-['Silkscreen'] tracking-[-0.16em] pb-[2.5px]",
        },
        sm: {
          title:
            "text-base sm:text-[13px] leading-[30px] sm:leading-[17px] font-['Silkscreen'] tracking-[-0.16em] sm:mb-1",
          subtitle:
            "text-[11px] leading-[1] !text-black font-['Silkscreen'] tracking-[-0.16em] pb-[2.5px]",
        },
      },
      event: {
        title: "text-[14px] tracking-[-0.06em] font-bold leading-[18px] text-black",
        subtitle: "text-[14px] tracking-[-0.06em] font-normal leading-[18px] text-black",
      },
      shop: {
        title: "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[20px] leading-6",
        text: "text-[14px] tracking-[-0.06em] leading-[18px] text-black",
        customShopImage: "/assets/customizations/skogsrejv/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header:
        "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[32px] leading-[32px]",
      title:
        "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[32px] leading-8 pb-2",
      description:
        "text-[11px] leading-[1] !text-black font-['Silkscreen'] tracking-[-0.16em] pb-[2.5px]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title:
        "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[32px] leading-8 pb-2",
      description:
        "text-[11px] leading-[1] !text-black font-['Silkscreen'] tracking-[-0.16em] pb-[2.5px]",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle:
        "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[32px] leading-10",
      sectionSubtitle: "text-[14px] tracking-[-0.06em] leading-[18px] font-medium text-black",
      text: "text-[14px] tracking-[-0.06em] leading-[18px] text-black",
      separator: "border-b border-[#161C24]",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#161C24",
        strokeColor: "border-[#2AD1FD]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "font-['Silkscreen'] tracking-[-0.16em] uppercase text-black text-[32px] leading-10",
        subtitle: "text-[14px] leading-[18px] font-medium text-black",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] leading-6 font-['Silkscreen'] tracking-[-0.16em] text-black uppercase",
        description: "text-[16px] leading-[16px] font-['Silkscreen'] tracking-[-0.16em] text-black",
        text: "text-[14px] tracking-[-0.06em] leading-[18px] text-black",
        price: "text-[24px] leading-6 font-['Silkscreen'] tracking-[-0.16em] text-black",
        quantity: "text-[16px] tracking-[-0.06em] leading-5 font-bold text-black",
      },
    },
  },
}

export default skogsrejv
